module.exports = __webpack_public_path__ + "img/cajaChicas.06cdad67.svg";